import { render, staticRenderFns } from "./sidebarMobile.vue?vue&type=template&id=6812bbd9&scoped=true"
import script from "./sidebarMobile.vue?vue&type=script&lang=js"
export * from "./sidebarMobile.vue?vue&type=script&lang=js"
import style0 from "./sidebarMobile.vue?vue&type=style&index=0&id=6812bbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812bbd9",
  null
  
)

export default component.exports